<template>
    <section class="monitoringProviderOdfStack" data-open="0">
      <h2><button @click="close($event)"></button><span>{{name}}</span><span class="count">{{ total }}</span></h2>
      <ul>
        <li v-for="(value, directory) in directories" :key="directory">
          <monitoringProviderOdfStack :directory="value" :name="directory" :path="path+'/'+directory" @count-child="updateChild"/>
        </li>
      </ul>
      <ul>
        <li v-for="(file) in files" :key="file" :data-name="file">
          <span>{{ file }}</span>
          <button class="resend" @click="resend(path+'/'+file)">Resend</button>
        </li>
      </ul>
    </section>
</template>

<script>
export default {
  name: 'monitoringProviderOdfStack',
  props: [
    'path',
    'directory',
    'name'
  ],
  data () {
    return {
      children: [],
      total: 0
    }
  },
  computed: {
    directories () { return this.directory.directories },
    files () { return this.directory.files },
    countFiles () { return this.files.length }
  },
  methods: {
    close: function (event) {
      const node = event.target.parentNode.parentNode
      node.setAttribute('data-open', node.getAttribute('data-open') === '0' ? '1' : '0')
    },
    count: function () {
      let value = 0
      for (const path in this.children) {
        value = value + this.children[path]
      }
      return value + this.countFiles
    },
    updateChild: function (value) {
      this.children[value.path] = parseInt(value.count)
      this.send()
    },
    resend: function (name) {
      this.$store.dispatch('ProviderOdf/resend', name)
    },
    send: function () {
      const value = { path: this.path, count: this.count() }
      this.total = this.count()
      this.$emit('count-child', value)
    }
  },
  created () {
    this.send()
  }
}
</script>

<style>
.monitoringProviderOdfStack{
  color: white;
  display:flex;
  flex-direction:column
}
.monitoringProviderOdfStack > h2{
  display:flex;
  align-items:center;
  margin:0
}
.monitoringProviderOdfStack > h2 > span{
  margin-left:5px;
  font-size:16px
}
.monitoringProviderOdfStack > h2 > span.count{
  color:grey
}
.monitoringProviderOdfStack > h2 button{
  display:flex;
  width:30px;
  margin:0 0 0 5px;
  background-color:transparent;
  border-width:1px;
  border-style:solid;
  border-radius:4px;
  font-weight:bold;
  font-size:20px;
  line-height:20px;
  transition:all .2s ease-in-out;
  cursor:pointer;
  padding:0;
  justify-content:center;
  align-items:center
}
.monitoringProviderOdfStack[data-open="0"] > h2 > button{
  border-color:grey;
  color:grey
}
.monitoringProviderOdfStack[data-open="0"] > h2 > button:hover{
  border-color:lightgrey;
  color:lightgrey
}
.monitoringProviderOdfStack[data-open="0"] > h2 > button::after{
  content:'+'
}
.monitoringProviderOdfStack[data-open="1"] > h2 > button{
  border-color:green;
  color:green
}
.monitoringProviderOdfStack[data-open="1"] > h2 > button:hover{
  border-color:lightgreen;
  color:lightgreen
}
.monitoringProviderOdfStack[data-open="1"] > h2 > button::after{
  content:'-'
}
.monitoringProviderOdfStack > ul{
  list-style:none;
  margin:5px 0 0 0;
  padding:0 0 0 20px
}
.monitoringProviderOdfStack[data-open="0"] > ul{
  display:none
}
.monitoringProviderOdfStack li[data-name*="-Computed"]{
  color:greenyellow
}
.monitoringProviderOdfStack li[data-name*="-Ignored"]{
  color:darkorange
}
.monitoringProviderOdfStack > ul > li{
  display:flex;
  align-items:center;
  line-height:16px;
  margin-bottom:1px
}
.monitoringProviderOdfStack > ul > li > button.resend{
  background-color:transparent;
  color:grey;
  border:1px solid grey;
  border-radius:4px;
  margin-left:5px;
  cursor:pointer;
  transition:all .2s ease-in-out
}
.monitoringProviderOdfStack > ul > li > button.resend:hover{
  color:lightgrey;
  border-color:lightgrey
}
</style>
